import { useState } from "react";
import "./Login.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useQuiz } from "../Quiz_Page/Context/QuizContext";

const Login = () => {
  const [name, setNames] = useState();
  const [email, setEmails] = useState();
  const { setName, setEmail } = useQuiz();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setName(name);
    setEmail(email);
    localStorage.setItem("name", name);
    localStorage.setItem("email", email);
    navigate("/Quiz_home");
  };

  return (
    <div>
      <motion.div
        className="co-container"
        initial={{ x: "7rem", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{
          duration: 2,
          type: "spring",
        }}
      >
        <h1>LOGIN</h1>
        <form onSubmit={handleSubmit}>
          <div className="text-field">
            <label htmlFor="name">Name:</label>
            <input
              id="name"
              type="text"
              onChange={(e) => {
                setNames(e.target.value);
                setName(e.target.value);
              }}
            />
          </div>

          <div className="text-field">
            <label htmlFor="email">Email:</label>
            <input
              id="email"
              type="email"
              onChange={(e) => {
                setEmails(e.target.value);
                setEmail(e.target.value);
              }}
            />
          </div>

          <button className="btn" type="submit">
            Submit
          </button>
          <p className="text-field">
            <span style={{ color: "red" }}>*</span>Note : Login is required to
            access the Quiz page. If you have already Logged-in, you may
            proceed.
          </p>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;
